import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { loadMarketCatalog, type MarketCatalogResult } from "@/lib/market-catalog";
import { renderMarketPublicOffline } from "@/lib/market-public-offline-gate";
import { MarketPageSkeleton } from "@/components/market/MarketSkeletons";
import { ClassBookingWidget } from "@/components/market/ClassBookingWidget";

const fetchCatalog = createServerFn({ method: "GET" })
  .inputValidator((slug: string) => slug)
  // @ts-expect-error ServerFnCtx framework type mismatch
  .handler(async ({ data: slug }) => loadMarketCatalog(slug, { request: getRequest() }));

export const Route = createFileRoute("/market_/$slug/clases")({
  pendingComponent: MarketPageSkeleton,
  pendingMs: 0,
  loader: async ({ params }) => fetchCatalog({ data: params.slug }),
  component: ClasesPage,
  head: ({ params, loaderData }) => {
    const result = loaderData as MarketCatalogResult | undefined;
    const name = result?.ok ? result.data.tenant.name : params.slug;
    return {
      meta: [
        { title: `Clases en ${name}` },
        { name: "description", content: `Inscribite a una clase en ${name}` },
      ],
    };
  },
});

function ClasesPage() {
  const { slug } = Route.useParams();
  const result = Route.useLoaderData() as MarketCatalogResult;
  const offline = renderMarketPublicOffline(result);
  if (offline) return offline;
  if (!result.ok) return null;
  return <ClassBookingWidget slug={slug} tenantName={result.data.tenant.name} />;
}
